import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { keyMomentsRo } from '../../../data/bookDataRo';
import SectionHeading from '../../SectionHeading';
import { FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const TimelineTeaserRo = () => {
  const featured = keyMomentsRo.slice(0, 5);
  return (
    <section className="py-24 bg-brand-surface relative border-t border-white/5">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <SectionHeading title="Cinci Secole de Istorie" subtitle="Momente Cheie" />
        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-brand-accent/50 via-brand-accent/20 to-transparent md:-translate-x-1/2"></div>
          <div className="space-y-8">
            {featured.map((moment, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: i % 2 === 0 ? -30 : 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                className={`relative flex gap-6 md:gap-0 ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}
              >
                <div className="absolute left-4 md:left-1/2 w-3 h-3 bg-brand-accent rounded-full -translate-x-1/2 mt-5 z-10 shadow-[0_0_10px_rgba(234,179,8,0.5)]"></div>
                <div className={`pl-12 md:pl-0 w-full md:w-1/2 ${i % 2 === 0 ? 'md:pr-12 md:text-right' : 'md:pl-12'}`}>
                  <div className="bg-brand-dark border border-white/5 rounded-xl p-5 hover:border-brand-accent/20 transition-colors">
                    <span className="text-brand-accent font-display font-bold text-lg">{moment.year}</span>
                    <h4 className="text-white font-semibold mt-1">{moment.event}</h4>
                    <p className="text-gray-500 text-sm mt-1">{moment.detail}</p>
                  </div>
                </div>
                <div className="hidden md:block w-1/2"></div>
              </motion.div>
            ))}
          </div>
        </div>
        <div className="text-center mt-12">
          <Link to="/ro/story" className="inline-flex items-center gap-2 text-brand-accent hover:text-white transition-colors font-medium">
            Explorează Povestea Completă <SafeIcon icon={FiArrowRight} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TimelineTeaserRo;